import { Api } from '../api';
import { profile } from '../endpoints';
import type { ApiResponse } from '../../models';
import type { UsersFeaturesResponse } from '../users';
import type { ProfileResponse } from './models';

export class ProfileApi extends Api {
  static getProfile = async (signal?: AbortSignal) => {
    const res = await this.get<ApiResponse<ProfileResponse>>({ url: profile.getProfile(), signal });
    return res.data;
  };

  static getProfileFeatures = async (signal?: AbortSignal) => {
    const res = await this.get<ApiResponse<UsersFeaturesResponse>>({ url: profile.getProfileFeatures(), signal });
    return res.data;
  };

  static updateAddress = (data: UpdateAddressRequest, signal?: AbortSignal) =>
    this.put<UpdateAddressRequest, ApiResponse<string>>({ url: profile.updateAddress(), data, signal });
}

interface UpdateAddressRequest {
  Type: 'Primary' | 'Billing';
  CountryCode: string;
  City: string;
  Street1: string;
  Street2: string;
  PostalCode: string;
}
